import ControllerBase from 'global/js/ControllerBase';

interface ComponentRefs {
	navbar: 'navbar';
}

export default class ControllerNavigation extends ControllerBase<ComponentRefs> {

	private navbar: HTMLDivElement;
	private allDropdowns: any;
	private logoSVG: HTMLElement | null;
	private logoType: string | null;
	private body: HTMLBodyElement;

	constructor(element: HTMLElement) {
		super(element);
		this.navbar = this.$references.navbar.parentElement as HTMLDivElement;
		this.allDropdowns = this.navbar.querySelectorAll('.m-nav-bar__dropdown');

		this.init();
		this.themeHandler();
	}

	private init() {
		if (this.navbar.classList.contains('overlap')) {
			window.addEventListener('scroll', (e) => this.detectPosition(e));

			this.navbar.addEventListener('mouseenter', () => {
				this.navbar.classList.add('hovering');
			});
			this.navbar.addEventListener('mouseleave', () => {
				this.navbar.classList.remove('hovering');
			});

			this.allDropdowns.forEach((dropdown) => {
				dropdown.addEventListener('mouseenter', () => {
					this.navbar.classList.add('dropdown-active');
				});
				dropdown.addEventListener('mouseleave', () => {
					this.navbar.classList.remove('dropdown-active');
				});
			});

			// Remove previous events created
			window.removeEventListener('unload', (e) => this.detectPosition(e));
		}
	}

	private handleHover() {
		if (this.navbar.classList.contains('on-top')) {
			this.navbar.classList.remove('on-top');
		} else if (!this.navbar.classList.contains('is-scrolling')) {
			this.navbar.classList.add('on-top');
		}
	}

	private detectPosition(e) {
		// Window scroll higher than the nav height
		if (e.currentTarget && e.currentTarget.scrollY > this.navbar.offsetHeight) {
			this.navbar.classList.remove('on-top');
			this.navbar.classList.add('is-scrolling');
		} else {
			this.navbar.classList.remove('is-scrolling');
			this.navbar.classList.add('on-top');
		}
	}

	private themeHandler() {
		this.body = document.getElementsByTagName('body')?.[0];
		this.logoSVG = this.$element.querySelector('.a-wolf-logo > svg');
		if (this.logoSVG) this.logoType = this.logoSVG.getAttribute('data-logo');
		if (this.body && this.logoType) this.body?.setAttribute("data-theme", this.logoType); // wolf, proklima, mediacenter
	}

}
